import * as Constants from './constants';
import { BaseLinkPreviewObject } from './BaseLinkPreviewObject';
import { createWebpageLinkPreviewObject } from './WebpageLinkPreviewObject';
import { createVideoLinkPreviewObject } from './VideoLinkPreviewObject';
import GetLinkPreviewResponse from 'owa-service/lib/contract/GetLinkPreviewResponse';
import LinkPreview from 'owa-service/lib/contract/LinkPreview';
import getLinkPreview from '../services/getLinkPreview';
import { trace } from 'owa-trace';
import { isSharePointLink } from 'owa-sharepoint-link-detector';

export default async function createLinkPreview(
    anchor: HTMLAnchorElement,
    inCompose: boolean
): Promise<BaseLinkPreviewObject> {
    let lp: BaseLinkPreviewObject = null;
    if (
        anchor.id.indexOf(Constants.LINK_PREVIEW_ANCHOR_ID) === 0 ||
        anchor.id.indexOf(Constants.NO_LINK_PREVIEW_ANCHOR_ID) === 0
    ) {
        // don't do anything. Link preview already exists/is in process for this anchor
    } else {
        // We will not provide link preview for SharePoint link and do not want to touch their id neither
        if (isSharePointLink(anchor.href)) {
            return lp;
        }

        // We need to make a server request for LinkPreview information.
        // First, update the anchor to keep track of the request in progress
        if (anchor.id && anchor.id.length > 0) {
            anchor.id = Constants.LINK_PREVIEW_ANCHOR_ID + anchor.id;
        } else {
            anchor.id = Constants.LINK_PREVIEW_ANCHOR_ID + Constants.createLinkPreviewIdNumber();
        }

        // Now, make the service request
        let response: GetLinkPreviewResponse = await getLinkPreview(anchor.href, anchor.id);

        if (!response) {
            trace.error('No response for getLinkPreview request with id: ' + anchor.id);
        } else {
            lp = buildLinkPreviewFromServerResponse(response, anchor, inCompose);
        }
    }

    return lp;
}

function buildLinkPreviewFromServerResponse(
    serverResponse: GetLinkPreviewResponse,
    anchor: HTMLAnchorElement,
    inCompose: boolean
): BaseLinkPreviewObject {
    if (!serverResponse.Error) {
        if (serverResponse.IsDisabled) {
            // TODO: update enabled/disable state
        } else {
            return buildLinkPreviewObjectFromLinkPreview(
                serverResponse.LinkPreview,
                anchor,
                inCompose
            );
        }
    } else {
        trace.info('GetLinkPreview returned error response: ' + serverResponse.Error);
    }

    return null;
}

function buildLinkPreviewObjectFromLinkPreview(
    linkPreview: LinkPreview,
    anchor: HTMLAnchorElement,
    inCompose: boolean
): BaseLinkPreviewObject {
    if (linkPreview) {
        switch (linkPreview.__type) {
            case Constants.BING_RTP_LINK_PREVIEW_TYPE:
                return createWebpageLinkPreviewObject(linkPreview, anchor, inCompose);
            case Constants.BING_VIDEO_LINK_PREVIEW_TYPE:
                return createVideoLinkPreviewObject(linkPreview, anchor, inCompose);
        }
    }

    return null;
}
